<!--
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-09-18 17:30:35
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-09-20 16:13:53
 * @FilePath     : \youxi\youxi\src\components\PxTimeline.vue
 * @Description  : Description
-->
<template>
  <div class="px-timeline">
    <div class="px-timeline-item" v-for="(v, i) in list" :key="i">
      <div class="px-timeline-item__date">{{ getDate(v, i) }}</div>
      <div
        :class="[
          i < step
            ? 'px-timeline-item__icon'
            : 'px-timeline-item__icon--disabled'
        ]"
      >
        <span class="icon-circle"></span>
        <span class="icon-line"></span>
      </div>
      <div class="px-timeline-item__desc">
        <div class="px-timeline-item__time">{{ v.create_time }}</div>
        <div class="px-timeline-item__msg">{{ v.msg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    step: {
      type: Number,
      default: 1
    }
  },
  methods: {
    // 获取左侧日期  v 数据对象 i 索引
    getDate(v, i) {
      const date = this.list.map(item => item.create_time.substr(0, 10));
      const time = v.create_time.substr(0, 10);
      if (i === 0) {
        return time;
      }
      if (time === date[i - 1]) {
        return "";
      }
      return time;
    }
  }
};
</script>

<style lang="less">
.px-timeline {
  width: 380px;
  &-item {
    display: flex;
    margin-bottom: 8px;
    &__date {
      width: 140px;
      min-height: 50px;
      text-align: right;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333;
    }
    &__icon {
      width: 50px;
      min-height: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon-circle {
        width: 16px;
        height: 16px;
        border: 1px solid rgba(107, 173, 248, 0.35);
        border-radius: 50%;
        position: relative;
        &::after {
          position: absolute;
          content: "";
          top: 4px;
          left: 4px;
          width: 8px;
          height: 8px;
          background: #F7F5F2;
          border-radius: 50%;
        }
      }
      .icon-line {
        margin-top: 5px;
        width: 2px;
        flex: 1;
        background: linear-gradient(
          180deg,
          #F7F5F2 0%,
          rgba(107, 173, 248, 0) 100%
        );
        border-radius: 4px;
      }
    }
    &__icon--disabled {
      width: 50px;
      min-height: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon-circle {
        width: 14px;
        height: 14px;
        background: #fff;
        border: 1px solid #c7c7c7;
        border-radius: 50%;
      }
      .icon-line {
        margin-top: 5px;
        width: 2px;
        flex: 1;
        background: linear-gradient(
            180deg,
            #e1e1e1 0%,
            rgba(225, 225, 225, 0) 100%
          ),
          linear-gradient(180deg, #e1e1e1 0%, rgba(225, 225, 225, 0) 100%);
        border-radius: 4px;
      }
    }
    &__desc {
      width: 207px;
      min-height: 50px;
    }
    &__time {
      color: #999;
      margin: 2px 0 5px 0;
    }
    &__msg {
      color: #333;
    }
  }
}
</style>
